export default __webpack_public_path__ + "static/img/5.e41c72d.png";